import React from "react";
import { Envelope, PlugsConnected } from "@phosphor-icons/react";

// How one delivery destination receives this buyer's leads (email addresses or their system's web address).
export function BuyerDeliveryMethod({ dest }) {
  const info = dest.delivery || {};
  const tid = `buyer-dest-method-${dest.id}`;
  if (info.method === "email") {
    return (
      <div className="mt-2 text-[11px] leading-relaxed" data-testid={tid}>
        <div className="inline-flex items-center gap-1 font-bold uppercase tracking-widest text-[10px]">
          <Envelope size={12} weight="bold" /> By email
        </div>
        <div className="font-mono break-all" data-testid={`${tid}-emails`}>
          {info.emails?.length ? info.emails.join(", ") : "No email address set yet. Ask your account manager."}
        </div>
      </div>
    );
  }
  return (
    <div className="mt-2 text-[11px] leading-relaxed" data-testid={tid}>
      <div className="inline-flex items-center gap-1 font-bold uppercase tracking-widest text-[10px]">
        <PlugsConnected size={12} weight="bold" /> Sent to your system (webhook)
      </div>
      <div className="font-mono break-all" data-testid={`${tid}-url`}>
        {info.url ? `${info.http_method || "POST"} ${info.url}` : "No web address set yet. Ask your account manager."}
      </div>
    </div>
  );
}
